module.exports={
	"Form": "FundingCategoryEditManifest",
	"Scope": "FundingCategory-Edit",
	"Descriptors":
	{
		"FundingCategoryDetails.Name":
		{
			"Name": "Name",
			"Hash": "FundingCategory-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "FundingCategory-Edit-Identity",
				"Group": "FundingCategory-Edit-Identity"
			}
		},
		"FundingCategoryDetails.Code":
		{
			"Name": "Code",
			"Hash": "FundingCategory-Edit-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "FundingCategory-Edit-Identity",
				"Group": "FundingCategory-Edit-Identity"
			}
		},
		"FundingCategoryDetails.Type":
		{
			"Name": "Type",
			"Hash": "FundingCategory-Edit-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Select2",
				"Row": "2",
				"Width": 4,
				"Section": "FundingCategory-Edit-Details",
				"Group": "FundingCategory-Edit-Details",
				"AllowCustomValues": false,
				"SelectOptions":
				[
					{
						"id": "Participating",
						"text": "Participating"
					},
					{
						"id": "Non-Participating",
						"text": "Non-Participating"
					},
					{
						"id": "Both",
						"text": "Both"
					}
				]
			}
		},
		"FundingCategoryDetails.Description":
		{
			"Name": "Description",
			"Hash": "FundingCategory-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "FundingCategory-Edit-Details",
				"Group": "FundingCategory-Edit-Details"
			}
		},
		"FundingCategoryDetails.IDFundingCategory":
		{
			"Name": "IDFunding Category",
			"Hash": "FundingCategory-Edit-IDFundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingCategory-Edit-DataAudit",
				"Group": "FundingCategory-Edit-DataAudit"
			}
		},
		"FundingCategoryDetails.GUIDFundingCategory":
		{
			"Name": "GUIDFunding Category",
			"Hash": "FundingCategory-Edit-GUIDFundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingCategory-Edit-DataAudit",
				"Group": "FundingCategory-Edit-DataAudit"
			}
		},
		"FundingCategoryDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "FundingCategory-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingCategory-Edit-DataAudit",
				"Group": "FundingCategory-Edit-DataAudit"
			}
		},
		"FundingCategoryDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "FundingCategory-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingCategory-Edit-DataAudit",
				"Group": "FundingCategory-Edit-DataAudit"
			}
		},
		"FundingCategoryDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "FundingCategory-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingCategory-Edit-DataAudit",
				"Group": "FundingCategory-Edit-DataAudit"
			}
		},
		"FundingCategoryDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "FundingCategory-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingCategory-Edit-DataAudit",
				"Group": "FundingCategory-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "FundingCategory-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "FundingCategory-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "FundingCategory-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "FundingCategory-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "FundingCategory-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "FundingCategory-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
